<!--
 * @Descripttion: monaco编辑器
 * 
 * ps: 在开启块状模式后，若需要自定块状样式，为了优化性能需要把inlineClassName属性上且类名须以"editor-"开头; eg: {inlineClassName: "editor-custom-style"}
 * 
 * @Author:Chenqy
 * @Date: 2023-07-31 17:43:28
 * @LastEditors: Chenqy
 * @LastEditTime: 2023-08-29 16:59:25
-->
<template>
  <div
    class="dsf-monaco-editor-custom"
    ref="edit"
    :style="style"
  ></div>
</template>
<script>
const monacoLoader = require("_platform/editor/loader.js");

import {
  monacoRegisterLanguage,
  completionItemProviderForLocal,
  completionItemProviderForJupyter,
  hoverProvider,
  disposeAllProviders,
} from "./monacoConfig";
export default {
  name: "DsfMonacoCustom",
  props: {
    language: {
      type: String,
      default: "python",
    },
    editText: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: "100%",
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    theme: {
      type: String,
      default: "vs",
    },
    // 开启块状模式
    turnOnBlock: {
      type: Boolean,
      default: false,
    },
    // 自动提示内容
    // 格式：
    //  [{ name: "接口根",
    //     value: "root",
    //     type: "Module",
    //     detail: "根节点",
    //     children: []
    //   }]
    completionItems: {
      type: Array,
      default: () => [],
    },
    // 编辑器配置项
    // 配置项参考地址 https://microsoft.github.io/monaco-editor/docs.html#interfaces/editor.IStandaloneEditorConstructionOptions.html
    config: {
      type: Object,
      default: () => ({}),
    },
    // 加载提示功能
    loadTip: {
      type: Object,
      default: () => ({
        type: "local", // 支持local/jupyter 两种方式
        isOpenTip: false, // 是否开启提示
        localLanguage: [], // 本地支持语言
        jupyterLanguage: [], // jupyter支持语言
      }),
    },
    // 自定义提示
    loadTipCustom: {
      type: Function,
      default: null,
    },
    // 选中后回调
    suggestionSelectCallBack: {
      type: Function,
      default: null,
    },
    loadHover: {
      type: Object,
      default: () => ({
        isOpen: false,
        hoverCb: dsf.noop,
        language: [], // 支持语言
      }),
    },
    // loadLocalTip.type为jupyter时，须传入
    jupyterWs: {
      type: Object,
      default: () => null,
    },
    model: {
      type: String,
      default: "",
    },
    cancelJsDiagnostics: {
      type: Boolean,
      default: false,
    },
    cancelJsCompletionItems: {
      type: Boolean,
      default: false,
    },
    // 自定义块状样式
    // 参考地址 https://microsoft.github.io/monaco-editor/docs.html#interfaces/editor.IModelDecorationOptions.html
    customBlockStyle: {
      type: Function,
    },
  },
  computed: {
    style() {
      const { width, height } = this;
      const fixedWidth = width.toString().indexOf("%") !== -1 ? width : `${width}px`;
      const fixedHeight = height.toString().indexOf("%") !== -1 ? height : `${height}px`;
      return {
        width: fixedWidth,
        height: fixedHeight,
      };
    },
  },
  watch: {
    config: {
      handler(val) {
        if (this.editerInstance) {
          this.editerInstance.updateOptions(val);
        }
      },
      deep: true,
    },
    editText(val) {
      if (this.editerInstance) {
        this.editerInstance.setValue(val || "");
        this.handleParseZero2decoration();
      }
    },
    width(v) {
      this.updateLayout();
    },
    height() {
      this.updateLayout();
    },
    completionItems(val, old) {
      let newVal = JSON.stringify(val);
      let oldVal = JSON.stringify(old);
      if (this.editerInstance) {
        if (newVal !== oldVal) {
          if (this.loadTip.isOpenTip) {
            this.handleLoadCodeTip(val);
          }
        }
      }
      this.completionItemCeche = val;
    },
    jupyterWs: {
      handler(val) {
        if (val && this.editerInstance && this.loadJupyterTip) {
          this.handleOpenCodeTip();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    monacoLoader.load("", this.createdEditer);
    window.addEventListener("resize", this.updateLayout);
  },
  data() {
    return {
      languageMapping: {
        python: "customPython",
      },
      editerInstance: null,
      editModels: {},
      completionItemCeche: [],
      suggestionCommand: null, // 接受suggestion选中后的回调
      decorationsCollection: null, // 块状元素装饰器
      firstSelection: null,
      selectBlock: {}, // 选中的块中元素
      // decorationIds: []
    };
  },
  methods: {
    // 创建编辑器
    createdEditer() {
      let editDom = this.$refs.edit;
      // 注册python语言
      monacoRegisterLanguage("customPython");
      // 新建模型
      let { model } = this.createModel(this.model || dsf.uuid(), this.language);
      if (!model) {
        return;
      }
      this.editerInstance = window.monaco.editor.create(editDom, {
        model: model,
        theme: this.theme,
        unicodeHighlight: {
          invisibleCharacters: false,
        }, // 隐藏零宽字符特殊显示
        ...this.config,
      });
      // console.log(this.editerInstance);
      // 是否取消monaco语义校验
      if (this.cancelJsDiagnostics) {
        monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
          noSemanticValidation: true,
          noSyntaxValidation: true,
        });
      }
      // 是否取消js语言下拉提示
      if (this.cancelJsCompletionItems) {
        monaco.languages.typescript.javascriptDefaults.setModeConfiguration({
          completionItems: false,
        });
      }
      // 添加快捷键 ctrl+s
      // this.editerInstance.addCommand(
      //   monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS,
      //   () => {
      //     const code = this.editerInstance.getValue();
      //     this.$emit("editorSave", code);
      //   }
      // );
      // // 添加快捷键alt+f8
      // this.editerInstance.addCommand(monaco.KeyCode.F8, () => {
      //   const code = this.editerInstance
      //     .getModel()
      //     .getValueInRange(this.editerInstance.getSelection());
      //   this.$emit("runcode", code);
      // });

      // monaco实例在销毁后并不会把addCommand绑定的方法连带销毁，且在同时存在两个实例时绑定相同key值的方法也会被覆盖，所以采用action代替。
      // 这个bug在新版本(至少0.40)貌似也没有修复
      this.editerInstance.addAction({
        id: "ctrls",
        label: "ctrls",
        // keybindings: [monaco.KeyMod.CtrlCmd, monaco.KeyCode.KeyS],
        keybindings: [monaco.KeyMod.chord(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS)],
        run: () => {
          const code = this.editerInstance.getValue();
          this.$emit("editorSave", code);
        },
      });
      this.editerInstance.addAction({
        id: "f8",
        label: "f8",
        keybindings: [monaco.KeyCode.F8],
        run: () => {
          const code = this.editerInstance.getModel().getValueInRange(this.editerInstance.getSelection());
          this.$emit("runcode", code);
        },
      });
      if (this.suggestionSelectCallBack) {
        this.suggestionCommand = window.monaco.editor.registerCommand("editor.suggest", (accessor, ...args) => {
          this.suggestionSelectCallBack(args);
        });
      }

      // 焦点失去后，保存代码
      // this.editerInstance.onDidBlurEditorText((e) => {
      //   const code = this.editerInstance.getValue();
      //   this.$emit("editorSave", code);
      // });
      // 监听值改变
      let _this = this;
      const changeValue = _.throttle(({ changes }) => {
        let value = _this.editerInstance.getValue();
        // 处理选中了块状元素，输入非backspace/delete键后，内容被删除，但是块状元素本身还存留问题。
        if (!dsf.isEmptyObject(_this.selectBlock)) {
          _this.handleParseZero2decoration();
          _this.selectBlock = {};
        }
        _this.$emit("changeValue", { changes, value });
      }, 50);
      this.editerInstance.onDidChangeModelContent(changeValue);
      // 初始化完成
      this.$emit("editLoaded", this.editerInstance);
      // HACK（处理用户是否为多选模式）
      // 块状模式
      if (this.turnOnBlock) {
        this.editerInstance.onDidChangeCursorSelection(this.handleChangeCursorSelection);
        // 确定焦点改变事件优先触发
        this.editerInstance.onMouseDown(() => {
          setTimeout(() => {
            this.firstSelection = this.editerInstance.getPosition();
          }, 50);
        });
        this.editerInstance.onMouseUp(() => {
          setTimeout(() => {
            const selection = this.editerInstance.getSelection();
            this.selectBlock = this.handleIsIndecorationRange(selection, true, true, true);
            this.firstSelection = null;
          }, 50);
        });
        // 重写删除事件
        // this.editerInstance.addCommand(monaco.KeyCode.Backspace, () => {
        //   this.handleResetBackspace();
        // });
        // this.editerInstance.addCommand(monaco.KeyCode.Delete, () => {
        //   this.handleResetBackspace(true);
        // });
        this.editerInstance.addAction({
          id: "backspace",
          label: "backspace",
          keybindings: [monaco.KeyCode.Backspace],
          run: () => this.handleResetBackspace(),
        });
        this.editerInstance.addAction({
          id: "delete",
          label: "delete",
          keybindings: [monaco.KeyCode.Delete],
          run: () => this.handleResetBackspace(true),
        });
        // 监听ctrl+v/ctrl+z/ctrl+y
        this.editerInstance.onKeyDown(({ metaKey, ctrlKey, keyCode }) => {
          const ck = dsf.client.isMac() ? metaKey : ctrlKey;
          if ((ck && (keyCode === 56 || keyCode === 52)) || keyCode === 55) {
            setTimeout(() => {
              this.handleParseZero2decoration();
            }, 50);
          }
        });
        this.handleParseZero2decoration();
      }
      // ==================== 加载提示信息 ====================
      if (this.loadTip.isOpenTip) {
        this.handleLoadCodeTip();
      }
      if (this.loadHover.isOpen) {
        this.handleLoadHoverTip();
      }
    },
    // =============================== 块状模式处理 ===============================
    /**
     * @description: 删除逻辑
     * @param {Boolean} isDelete 是否为delete键删除
     * @return {*}
     */
    handleResetBackspace(isDelete = false) {
      const { lineNumber, column } = this.editerInstance.getPosition();
      const selection = this.editerInstance.getSelection();
      const { endColumn, endLineNumber, startColumn, startLineNumber } = selection;
      let deleteElement = {};
      let hasBlock = false;
      // 判断是否为选中删除
      if (startLineNumber === endLineNumber && startColumn === endColumn) {
        deleteElement = this.handleIsIndecorationRange(selection, isDelete, true);
      } else {
        deleteElement = this.handleIsIndecorationRange(selection, false, true, true);
      }
      if (dsf.isEmptyObject(deleteElement)) {
        if (isDelete) {
          deleteElement = {
            lineNumbers: [startLineNumber, endLineNumber],
            columns: [startColumn, endColumn === startColumn ? endColumn + 1 : endColumn],
          };
        } else {
          deleteElement = {
            lineNumbers: [startLineNumber, endLineNumber],
            columns: [startColumn === endColumn ? startColumn - 1 : startColumn, endColumn],
          };
        }
      } else {
        hasBlock = true;
      }
      this.editerInstance.executeEdits("", [
        {
          range: new monaco.Range(deleteElement.lineNumbers[0], deleteElement.columns[0], deleteElement.lineNumbers[1], deleteElement.columns[1]),
          text: "",
          forceMoveMarkers: true, // 取消选中状态
        },
      ]);
      // 删除decoration数据
      if (hasBlock) {
        this.handleParseZero2decoration();
      }
      // 检查光标是否需要换行
      if (column === 1 && lineNumber !== 1) {
        const focusLineMaxColums = this.editerInstance.getModel().getLineMaxColumn(lineNumber) - 1;
        this.editerInstance.executeEdits("", [
          {
            range: new monaco.Range(lineNumber - 1, this.editerInstance.getModel().getLineMaxColumn(lineNumber - 1), lineNumber, 0),
            text: "",
            forceMoveMarkers: true, // 取消选中状态
          },
        ]);
        this.editerInstance.setPosition({
          lineNumber: lineNumber - 1,
          column: this.editerInstance.getModel().getLineMaxColumn(lineNumber - 1) - focusLineMaxColums,
        });
      }
    },
    // 监听光标移动事件
    handleChangeCursorSelection({ selection, source, oldSelections }) {
      const validSource = ["mouse", "keyboard"];
      if (this.decorationsCollection && validSource.includes(source)) {
        const isSingle = !this.firstSelection;
        // 目标decoration位置信息
        let targetPosition = {};
        // 找出当先区域是否含有块状元素
        targetPosition = this.handleIsIndecorationRange(selection);
        // 非选中模式
        if (isSingle) {
          // 如果有块状元素重新光标移动逻辑
          if (!dsf.isEmptyObject(targetPosition)) {
            const [left, right] = targetPosition.columns;
            const { column: currentPositionColum, lineNumber } = this.editerInstance.getPosition();
            // 利用鼠标移动焦点
            if (source === "mouse") {
              let range = {
                lineNumber,
                column: (left + right) / 2 > currentPositionColum ? left : right,
              };
              this.editerInstance.setPosition(range);
            } else {
              const direction = selection.endColumn > oldSelections[0].endColumn ? "toRight" : "toLeft";
              let range = {
                lineNumber: lineNumber,
                column: direction === "toRight" ? right : left,
              };
              this.editerInstance.setPosition(range);
            }
          }
        } else {
          const { positionLineNumber, positionColumn } = selection;
          const { lineNumber: firstLineNumber, column: firstPositionColumn } = this.firstSelection;
          if (dsf.isEmptyObject(targetPosition)) {
            targetPosition = {
              columns: [selection.positionColumn, selection.positionColumn],
            };
          }
          if (positionLineNumber > firstLineNumber || (positionLineNumber === firstLineNumber && positionColumn > firstPositionColumn)) {
            // 向后选
            this.editerInstance.setSelection({
              endColumn: targetPosition.columns[1],
              endLineNumber: positionLineNumber,
              startColumn: this.firstSelection.column,
              startLineNumber: this.firstSelection.lineNumber,
            });
          } else {
            // 向前选
            this.editerInstance.setSelection({
              endColumn: firstPositionColumn,
              endLineNumber: firstLineNumber,
              startColumn: targetPosition.columns[0],
              startLineNumber: positionLineNumber,
            });
          }
        }
        this.prevPosition = selection;
      }
    },
    /**
     * @description: 当前光标所在位置是否处于某个decoration内
     * @param {Monaco.Position} position 光标位置
     * @param {Boolean} prevClosure 是否为前闭合区间
     * @param {Boolean} afterClosure 是否为后闭合区间
     * @param {Boolean} reverse 找出position内的区间
     * @return {Monaco.Position/Monaco.Selection} decoration位置信息
     */
    handleIsIndecorationRange(position, prevClosure = false, afterClosure = false, reverse = false) {
      if (this.decorationsCollection) {
        const decorationPosition = this.decorationsCollection.getRanges();
        let i = 0;
        let data = {};
        while (i < decorationPosition.length) {
          const range = decorationPosition[i];
          const line = range.startLineNumber;
          const startColumn = range.startColumn + +!prevClosure;
          const endColumn = range.endColumn + +afterClosure;
          if (reverse) {
            const { endColumn, endLineNumber, startColumn, startLineNumber } = position;
            const { endColumn: rEndColumn, endLineNumber: rEndLineNumber, startColumn: rStartColumn, startLineNumber: rStartLineNumber } = range;
            if (startLineNumber <= rStartLineNumber && endLineNumber >= rEndLineNumber && startColumn <= rStartColumn && endColumn >= rEndColumn) {
              if (!data.index) {
                data = {
                  lineNumbers: [startLineNumber, endLineNumber],
                  columns: [startColumn, endColumn],
                  index: [i],
                };
              } else {
                data.index.push(i);
              }
            }
            i++;
          } else {
            if (line === position.positionLineNumber && _.inRange(position.positionColumn, startColumn, endColumn)) {
              return {
                lineNumbers: [line, line],
                columns: [range.startColumn, range.endColumn],
                index: [i],
              };
            } else {
              i++;
            }
          }
        }
        return data;
      } else {
        return {};
      }
    },
    // 获取所有的块状位置信息
    getAllBlockMessage() {
      this.handleParseZero2decoration();
      return this.decorationsCollection.getRanges();
    },
    // 解析零宽字符为装饰器
    handleParseZero2decoration() {
      const editPosition = this.editerInstance.getModel().findMatches(/ ?\u200b[^\u200b ?]+\u200b ?/, false, true);
      if (editPosition.length) {
        let decorations = [];
        for (let i = 0; i < editPosition.length; i++) {
          // let { endColumn, endLineNumber, startColumn, startLineNumber } =
          //   editPosition[i].range;
          // 设置装饰器
          const range = editPosition[i].range;
          const blockCode = this.editerInstance
            .getModel()
            .getValueInRange(range)
            .replace(/\u200b/g, "")
            .trim();
          decorations.push({
            range: range,
            options: this.handleDecorationOption(blockCode),
          });
        }
        if (this.decorationsCollection) {
          this.decorationsCollection.set(decorations);
        } else {
          this.decorationsCollection = this.editerInstance.createDecorationsCollection(decorations);
        }
      } else {
        // 清空所有块状
        this.decorationsCollection?.clear();
      }
    },
    // =============================== 块状模式处理 ===============================
    // 加载hover提示
    handleLoadHoverTip() {
      const langs = _.map(this.loadHover.language, this.getRealLanguage);
      hoverProvider(langs, this.loadHover.hoverCb);
    },
    // 加载代码提示
    handleLoadCodeTip(val) {
      if (this.loadTip.type === "local") {
        const langs = _.map(this.loadTip.localLanguage, this.getRealLanguage);
        completionItemProviderForLocal(val || this.completionItemCeche, langs, this.loadTipCustom);
      } else {
        const langs = _.map(this.loadTip.jupyterLanguage, this.getRealLanguage);
        completionItemProviderForJupyter(this.jupyterWs, langs);
      }
    },
    /**
     * @description: 创建monacoModel
     * @param {String} modelId modelId
     * @param {String} lang 语言类型
     * @param {String} code model内容
     * @result: monaco Model
     */
    createModel(modelId, lang, code) {
      let realLang = this.getRealLanguage(lang);
      let realCode = dsf.isUnDef(code) ? this.editText || "" : code;
      if (this.editModels[modelId]?.model) {
        return this.editModels[modelId];
      } else {
        let model = window.monaco.editor.createModel(realCode, realLang);
        this.editModels[modelId] = {
          model,
          viewState: null, // 视图状态
        };
        return { model };
      }
    },
    // 更换语种
    changeLang(lang, modelId) {
      let model = this.editModels[modelId]?.model;
      let realLang = this.getRealLanguage(lang);
      if (model) {
        window.monaco.editor.setModelLanguage(model, realLang);
      }
    },
    // 更换Model
    changeModel(modelId, prevModelId) {
      let prevModel = this.editModels[prevModelId];
      // 保存视图状态
      if (prevModel) {
        let viewState = this.editerInstance.saveViewState();
        prevModel.viewState = viewState;
      }
      let model = this.editModels[modelId];
      if (model.model) {
        this.editerInstance.setModel(model.model);
        model.viewState && this.editerInstance.restoreViewState(model.viewState);
        // 重置块状元素样式
        if (this.turnOnBlock) {
          this.handleParseZero2decoration();
        }
      } else {
        dsf.layer.message("编辑器不存在该Model", false);
      }
    },
    // 新增model
    addModel(modelId, lang, code, prevModelId) {
      let prevModel = this.editModels[prevModelId];
      // 保存视图状态
      if (prevModel) {
        let viewState = this.editerInstance.saveViewState();
        prevModel.viewState = viewState;
      }
      let { model, viewState } = this.createModel(modelId, lang, code);
      if (model) {
        this.editerInstance.setModel(model);
        // 重置块状元素样式
        if (this.turnOnBlock) {
          this.handleParseZero2decoration();
        }
        viewState && this.editerInstance.restoreViewState(viewState);
        this.$nextTick(() => {
          this.editerInstance.layout();
        });
      }
    },
    // 删除model
    delModel(modelId) {
      let model = this.editModels[modelId]?.model;
      if (model) {
        model.dispose();
        setTimeout(() => {
          delete this.editModels[modelId];
        }, 50);
      }
    },
    getRealLanguage(lang) {
      return this.languageMapping[lang] || lang;
    },
    getValue() {
      return this.editerInstance.getValue();
    },
    /**
     * @description: 添加代码
     * @param {String} code   代码串
     * @param {String} type   添加方式  参考值：[focus, end]
     * @param {Object} config 块状元素配置
     *   @param {Boolean} isAddBlock   是否未块状变量
     *   @param {String}  className    块状变量类名
     *   @param {Object}  afterContent 后续追加非块状内容
     *     @param {String} value     追加代码
     *     @param {Number} position  焦点位置(规则: 从当前位置平移position个单位)
     * @return {*}
     */
    addCode(insertObj, type = "focus", config = {}) {
      let code = "";
      if (dsf.isString(insertObj)) {
        code = insertObj;
      } else if (dsf.isObject(insertObj)) {
        code = insertObj.value;
      }
      if (this.editerInstance) {
        let range = null;
        if (type === "focus") {
          let selection = this.editerInstance.getSelection();
          range = new monaco.Range(selection.startLineNumber, selection.startColumn, selection.endLineNumber, selection.endColumn);
        } else {
          const maxLine = this.editerInstance.getModel().getLineCount();
          range = new monaco.Range(maxLine + 1, 1, maxLine + 1, 1);
        }
        let op = {
          range: range,
          text: code,
          forceMoveMarkers: true, // 取消选中状态
        };
        // 块状元素处理
        if (this.turnOnBlock && config.isAddBlock) {
          op.text = `\u200b${code}\u200b`;
          // 追加非块状元素
          if (config?.afterContent?.value) {
            op.text += config?.afterContent?.value;
          }
          const decorationRange = [
            range.startLineNumber,
            range.startColumn,
            range.startLineNumber,
            range.startColumn + code.length + 2, // 2为零宽字符长度
          ];
          //
          if (dsf.isEmptyObject(this.selectBlock)) {
            if (this.decorationsCollection) {
              // 重新获取之前块状信息
              let decorations = [];
              decorations.push(...this.getAllDecoration(op.range, op.text.length));
              // 追加代码串addcode
              this.editerInstance.executeEdits("", [op]);
              // 添加新入的块状变量信息
              decorations.push({
                range: new monaco.Range(...decorationRange),
                options: this.handleDecorationOption(insertObj),
              });
              this.decorationsCollection.set(decorations);
            } else {
              this.editerInstance.executeEdits("", [op]);
              this.decorationsCollection = this.editerInstance.createDecorationsCollection([
                {
                  range: new monaco.Range(...decorationRange),
                  options: this.handleDecorationOption(insertObj),
                },
              ]);
            }
          } else {
            // 若有选中块状元素，在值变化时会统一处理。所以这不在去计算之前的块状元素位置信息。
            this.editerInstance.executeEdits("", [op]);
          }
          // 处理光标位置
          if (!dsf.isUnDef(config?.afterContent?.position)) {
            const { column, lineNumber } = this.editerInstance.getPosition();
            const endColumn = column + config.afterContent.position;
            this.editerInstance.setPosition(new monaco.Position(lineNumber, endColumn));
          }
        } else {
          this.editerInstance.executeEdits("", [op]);
        }
        this.editerInstance.focus();
      }
    },
    // 元素装饰器设置
    handleDecorationOption(options) {
      // 自定义样式
      if (dsf.isFunction(this.customBlockStyle)) {
        return this.customBlockStyle(options);
      }
      return {
        inlineClassName: options?.className || "editor-custom-block",
        stickiness: monaco.editor.TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges, // 边缘输入时不进行装饰
        description: options,
      };
    },
    // 更新编辑器布局
    updateLayout() {
      if (this.editerInstance) {
        this.editerInstance.layout();
      }
    },
    setValue(content) {
      this.editerInstance.setValue(content);
    },
    // 获取所有的块状元素
    handleGetAllDeracations() {
      return this.editerInstance.getModel().getAllDecorations("", true);
    },
    /**
     * @description: 获取所有decoration信息
     * @param {monaco.Range} basePosition 当前光标位置
     * @param {number} codeLength 添加字符长度
     * @return {*}
     */
    getAllDecoration({ startColumn, startLineNumber }, codeLength) {
      const decorations = this.editerInstance.getModel().getAllDecorations("", true);
      let d = [];
      for (let i = 0, j = decorations.length; i < j; i++) {
        let item = decorations[i];
        const { inlineClassName = "", description = {} } = item.options;
        if (/^editor-/.test(inlineClassName)) {
          const { endColumn: cec, startColumn: csc, startLineNumber: csl } = item.range;
          let range = {};
          // 如果块状元素在光标处的后面
          if (startLineNumber === csl && csc >= startColumn) {
            range = new monaco.Range(startLineNumber, csc + codeLength, startLineNumber, cec + codeLength);
          } else {
            range = item.range;
          }
          d.push({
            range,
            options: this.handleDecorationOption(description),
          });
        }
      }
      return d;
    },
  },
  beforeDestroy() {
    // 恢复js语义校验
    if (this.cancelJsDiagnostics) {
      monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: false,
        noSyntaxValidation: false,
      });
    }
    if (this.cancelJsCompletionItems) {
      monaco.languages.typescript.javascriptDefaults.setModeConfiguration({
        completionItems: true,
      });
    }
    window.removeEventListener("resize", this.updateLayout);
    disposeAllProviders();
    for (let key in this.editModels) {
      this.editModels[key]?.dispose?.();
    }
    if (this.editerInstance) {
      this.editerInstance?.dispose?.();
    }
    this.suggestionCommand?.dispose?.();
  },
};
</script>